import React, { Component, Fragment } from "react";
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import Address from "@common/components/addressGlobal/components/address.global.component";
import { Row, Col } from "react-bootstrap";
import DDados from "../socio.ddados";
import DDadosItem from "@common/components/ddados/ddados.item";
import socioActions from "../store/socio.actions";
import dadosSolicitanteActions from "../../dadosSolicitante/store/dadosSolicitante.actions";
import socioSelector from "../store/socio.selectors";
import { connect } from "@common/components/base.component";
import Button from "@material-ui/core/Button";
import focusHelper from "@common/helpers/focus.helper";
import Form from "@common/externos/components/validation/form.validation";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onClose() {
    this.props.socioActions.closeModalSocio();
    this.props.socioActions.resetStateSocio();
  }

  adicionar(form) {
    this.props.socioActions.addSagaListSocio(form);
  }

  handleCpfCnpjBlur(value) {
    const { socioSelector, form } = this.props;
    const { values } = form;
    const { socio } = socioSelector;

    var replaceMaskNew = value.replace(/[\._/-]/g, "").trim();
    var qtdCpfCnpjNew = replaceMaskNew.length;

    if (qtdCpfCnpjNew != 0 && value != socio.Dto.CpfCnpj) {
      if (value) this.props.socioActions.getSolicitante(value);
    }

    this.props.socioActions.setNewOpen();
  }

  handleSocioBlur = (value) => this.props.socioActions.setStateSocio(value);

  render() {
    const { Campos } = DDados;
    const { socioSelector, form } = this.props;
    const { socio } = socioSelector;
    const isView = socio.prefix == "V";
    const title =
      socio.prefix == "E"
        ? "Edição"
        : socio.prefix == "I"
        ? "Inclusão"
        : "Visualização";

    if (socio.newOpen) {
      focusHelper.focus("CpfCnpj");
    }

    return (
      <Modal
        className={"mt-5 mb-5"}
        show={socio.showModalSocio}
        onHide={this.onClose}
        enforceFocus={false}
        size="lg"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            <h3>{`${title} de Sócio`}</h3>
          </Modal.Title>
        </Modal.Header>
        <Form
          onSubmit={socio.prefix == "V" ? undefined : this.adicionar}
          boxForm
          removeWell={true}
          onCancel={this.onClose}
          prefix={socio.prefix}
          fromModal
        >
          {(form) => (
            <>
              <Modal.Body>
                <Col>
                  <DDadosItem
                    name="IdIdentificador"
                    {...Campos.IdIdentificador}
                    state={socio.Dto}
                  />
                </Col>
                <Row>
                  <Col lg={3}>
                    <DDadosItem
                      name="CpfCnpj"
                      {...Campos.CpfCnpj}
                      state={socio.Dto}
                      isView={isView}
                      onBlur={this.handleCpfCnpjBlur}
                    />
                  </Col>
                  <Col lg={9}>
                    <DDadosItem
                      name="Nome"
                      {...Campos.Nome}
                      state={socio.Dto}
                      isView={isView}
                      onBlur={(value) => this.handleSocioBlur({ Nome: value })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <DDadosItem
                      name="DataEntrada"
                      {...Campos.DataEntrada}
                      state={socio.Dto}
                      validateOnBlur
                      isView={isView}
                      onChange={(value) =>
                        this.handleSocioBlur({ DataEntrada: value })
                      }
                    />
                  </Col>
                  <Col lg={3}>
                    <DDadosItem
                      name="RgIe"
                      {...Campos.RgIe}
                      state={socio.Dto}
                      isView={isView}
                      onBlur={(value) => this.handleSocioBlur({ RgIe: value })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={3}>
                    <DDadosItem
                      name="Telefone"
                      {...Campos.Telefone}
                      state={socio.Dto}
                      isView={isView}
                      onBlur={(value) =>
                        this.handleSocioBlur({ Telefone: value })
                      }
                    />
                  </Col>
                  <Col lg={6}>
                    <DDadosItem
                      name="Email"
                      {...Campos.Email}
                      state={socio.Dto}
                      isView={isView}
                      onBlur={(value) => this.handleSocioBlur({ Email: value })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <Address
                      name="EnderecoSocio"
                      state={socio.Dto.EnderecoSocio}
                      prefix={socio.prefix}
                      onBlur={(values) =>
                        this.props.socioActions.setStateEnderecoSocio(values)
                      }
                    />
                  </Col>
                </Row>
              </Modal.Body>
            </>
          )}
        </Form>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    socioActions,
    dadosSolicitanteActions,
  },
  selectors: {
    socioSelector,
  },
})(Container);
